import React from "react";
import "./App.css";
import PopupDiv from "./PopupDiv";

function App() {
  return (
    <div className="App">
      <PopupDiv />
    </div>
  );
}

export default App;
